import { DecodedValueMap, StringParam } from "use-query-params";

/** Links that drill into the workspace Tasks page; the page applies them to its filters on mount, then drops them. */
export const WORKSPACE_TASKS_DRILL_DOWN_QUERY_PARAMS = {
    closeId: StringParam,
    entityId: StringParam,
    groupBy: StringParam,
    /** A built-in view to land on (see `resolveWorkspaceTasksLanding`). */
    view: StringParam,
};

type WorkspaceTasksDrillDownQueryParams = DecodedValueMap<
    typeof WORKSPACE_TASKS_DRILL_DOWN_QUERY_PARAMS
>;

/** The URL update that drops every drill-down param once the page applied them. */
export const CLEARED_WORKSPACE_TASKS_DRILL_DOWN_QUERY_PARAMS: Record<
    keyof WorkspaceTasksDrillDownQueryParams,
    undefined
> = {
    closeId: undefined,
    entityId: undefined,
    groupBy: undefined,
    view: undefined,
};

export const hasWorkspaceTasksDrillDownLink = (
    queryParams: WorkspaceTasksDrillDownQueryParams,
): boolean => Object.values(queryParams).some(Boolean);
